import {isEmpty, isUndefined, omitBy} from 'lodash';

import {keyValueStore} from '../../../libs/shared/core/src/services/storage/storage';
import {
  AnalyticsFilterTypesEnum,
  AnalyticsSavedViewTerms,
} from '../../../src/models/api/analyticsSavedViewModel';
import {AnalyticsParameters} from '../../../src/store/panels/analytics/parameters/analyticsParameters';

/*
 * Interfaces.
 */

interface LiveDashboardFilters {
  inboxIds: ReadonlyArray<number>;
  teammateIds: ReadonlyArray<number>;
  circleIds: ReadonlyArray<number>;
  hasWaitingMetrics: boolean | undefined;
}

/*
 * Constants.
 */

const liveDashboardFiltersKeyPrefix = 'liveDashboardFilters';

/*
 * Recent search queries.
 */

export function readLiveDashboardFiltersForNamespace(namespace: string): LiveDashboardFilters | undefined {
  const filtersJson = keyValueStore.read(`${liveDashboardFiltersKeyPrefix}:${namespace}`);
  return filtersJson ? JSON.parse(filtersJson) : undefined;
}

export function writeLiveDashboardFiltersForNamespace(namespace: string, filters: LiveDashboardFilters) {
  keyValueStore.set(`${liveDashboardFiltersKeyPrefix}:${namespace}`, JSON.stringify(filters));
}

/*
 * Helpers.
 */

export function getPartialLiveDashboardFiltersFromParameters(
  parameters: AnalyticsParameters,
): Partial<LiveDashboardFilters> | undefined {
  if (!parameters.filters) {
    return undefined;
  }
  const partialLiveDashboardFilters = omitBy(
    {
      inboxIds: findLiveDashboardIdsFilterInTerms(
        parameters.filters.terms,
        AnalyticsFilterTypesEnum.LIVE_DASHBOARD_INBOXES,
      ),
    },
    isUndefined,
  );

  if (isEmpty(partialLiveDashboardFilters)) {
    return undefined;
  }

  return partialLiveDashboardFilters;
}

function findLiveDashboardIdsFilterInTerms(
  terms: AnalyticsSavedViewTerms,
  filterType: AnalyticsFilterTypesEnum,
) {
  const liveDashboardFilter = terms.find((term) => term.type === filterType);
  const liveDashboardIdsFilter =
    liveDashboardFilter && 'ids' in liveDashboardFilter ? liveDashboardFilter.ids : undefined;
  return liveDashboardIdsFilter;
}
